import React, { useEffect, useRef } from "react";
import "./BusinessThreeNewsAndBlogs.scss";

const BusinessThreeNewsAndBlogs = ({ id }) => {
  const headingRef = useRef(null);

  // CODE START FOR ANIMATION HEADING
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          } else {
            entry.target.classList.remove("animate");
          }
        });
      },
      { threshold: 0.1 }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => {
      if (headingRef.current) {
        observer.unobserve(headingRef.current);
      }
    };
  }, []);
  // CODE END FOR ANIMATION HEADING
  return (
    <div className="news-n-blogs-three-parent" id={id}>
      <div className="medium_padding_div"></div>
      <div className="small_padding_div"></div>

      <div className="container business-three-box-container">
        <div ref={headingRef} className="business-three-heading-div">
        <h3>
            <span>News</span> and <span>Blog</span> Highlights
          </h3>
        </div>
        <div className="business-three-template-view-more-icon">
          <span class="material-symbols-outlined">arrow_forward_ios</span>
        </div>
      </div>
      <div className="container">
        <div className="row">
          {/* Left Column */}
          <div className="col-lg-6 col-12">
            <div className="news-n-blogs-three-left-parent">
              <img
                src="https://www.projecteurhd.com/wp-content/uploads/2023/10/meilleurs-videoprojecteurs-pour-ps5.jpg"
                alt="Main Blog"
              />
              <div className="content">
                <div className="date">29 Jul, 2025</div>
                <h4>
                  Guide to Buying the Perfect Projector
                </h4>
                <p>
                 Choosing the right projector can completely change your viewing experience — whether it's for movies, presentations, or gaming. In this guide, we explain key features to consider like resolution (HD, Full HD, 4K), brightness (lumens), throw distance, and connectivity options. We also share tips on choosing between LED, LCD, and DLP projectors based on your specific needs. If you're setting up a home theater or an office conference room, this blog will help you make the right decision confidently.


                </p>
                <button className="btn_fill">Read</button>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-6 col-12">
            <div className="row">
              {/* Top Right Card */}
              <div className="col-lg-12 col-12">
                <div className="news-n-blogs-three-right-parent">
                  <img
                    src="https://www.ooberpad.com/cdn/shop/files/Ooberpad-Vertical-Home-banner-Home-Theatre_Final.webp?v=1714467503&width=1920"
                    alt="Blog 1"
                  />
                  <div className="content">
                    <div className="date">29 Jul, 2025</div>
                    <h4>
                      Experience Clarity, Size & Brilliance with LED Walls
                    </h4>
                    <p>
                   From seamless video calls to stunning visual displays, our LED walls deliver crystal-clear resolution and immersive brightness. Ideal for offices, events, or homes — they redefine how you present, view, and connect.</p>
                    <button className="btn_fill">Read</button>
                  </div>
                </div>
              </div>

              {/* Bottom Right Card */}
              <div className="col-lg-12 col-12">
                <div className="news-n-blogs-three-right-parent">
                  <img
                    src="https://i0.wp.com/hushidaglobal.com/wp-content/uploads/2023/05/video-wall.webp?fit=800%2C600&ssl=1"
                    alt="Blog 2"
                  />
                  <div className="content">
                    <div className="date">29 Jul, 2025</div>
                    <h4>
                      Why Good led walls Matter for Your Daily Routine
                    </h4>
                    <p>
                      A high-quality LED wall isn’t just a display — it’s a powerful tool that enhances productivity, transforms presentations, and elevates your space. Whether for work, entertainment, or ambience, sharp visuals and vibrant colors make every moment clearer and more engaging.

                    </p>
                    <button className="btn_fill">Read</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="small_padding_div"></div>

      <div className="large_padding_div"></div>
    </div>
  );
};

export default BusinessThreeNewsAndBlogs;
